export let API_URL = "API_URL_PLACEHOLDER";

export async function getAppConfig() {
    const response = await fetch(`/config/config.json`);
    await response.json().then(response => API_URL = response.apiUrl);
    
}